export const INSPECTION_ERRAND_STATUS = {
  CREATED: 0,
  ACCEPTED: 1,
  STARTED: 2,
  PAUSED: 3,
  COMPLETED: 4,
  ANNULLED: 5,
} as const;

export const INSPECTION_ERRAND_VALIDITY_STATUS = {
  // 0 inspection faults
  VALID: 0,
  // More than 0 inspection faults
  INVALID: 1,
};

// class (IntegerChoices):
//     # 0 inspectionfaults
//     VALID = 0

//     INVALID = 1

// class TENANT_INSPECTION_ASSOCIATION_TYPES(models.IntegerChoices):
//     PREVIOUS_TENANT = 0
//     CURRENT_TENANT = 1
//     FUTURE_TENANT = 2

// class INSPECTION_FAULT_RESPONSIBLE_TYPES(models.IntegerChoices):
//     PREVIOUS_TENANT = 0
//     CURRENT_TENANT = 1
//     FUTURE_TENANT = 2

//     # owner, landlord, invoicing company etc (not counterpart)
//     OWNER_LANDLORD = 3

// class INSPECTION_ERRAND_AUTO_CREATE_TENANT_TYPES(models.IntegerChoices):
//     # we'll auto create inspections and include these tenants on the inspection

//     PREVIOUS_TENANTS = 0
//     FUTURE_TENANTS = 1
//     ALL_TENANTS = 2

export const INSPECTION_ERRAND_INVOICING_STATUS = {
  MISSING_COSTS: 0,
  PENDING_ERRAND_COST_DATA: 1,
  PENDING_INVOICE_CREATION: 2,
  PENDING_INVOICE_ATTEST: 3,
  PENDING_PARTLY_INVOICE_ATTEST: 4,
  ALL_INVOICES_ATTESTED: 5,
} as const;
